import * as React from "react";
import { Global } from "@emotion/react";

import { ThemeProvider, ThemeVariant } from "../Controls/Internals/ThemeProvider/ThemeProvider";

import { fontStyle, globalStyles, typographyStyles } from "./GlobalStyles/Global.styles";

interface CandyThemeWrapperProps {
    theme?: ThemeVariant;
    children: React.ReactNode;
}

export function updateDebugTheme(updateFn: (prevTheme: ThemeVariant | undefined) => ThemeVariant | undefined): void {
    const debugTheme = debugThemeStore.get();
    const nextTheme = updateFn(debugTheme ?? undefined);
    if (nextTheme == undefined) {
        debugThemeStore.reset();
    } else {
        debugThemeStore.set(nextTheme);
    }
    for (const forceUpdateThemeWrapper of forceUpdateThemeWrappers) {
        forceUpdateThemeWrapper();
    }
}

const forceUpdateThemeWrappers: Array<() => void> = [];

export function CandyThemeWrapper(props: CandyThemeWrapperProps): JSX.Element {
    function getCurrentTheme(): ThemeVariant {
        if (process.env.NODE_ENV === "development") {
            const debugTheme = debugThemeStore.get();
            if (debugTheme != undefined) {
                return debugTheme;
            }
        }
        return props.theme ?? ThemeVariant.Default;
    }

    const [, setStateBit] = React.useState(0);
    React.useEffect(() => {
        forceUpdateThemeWrappers.push(() => setStateBit(x => x + 1));
    }, []);

    return (
        <ThemeProvider theme={getCurrentTheme()}>
            <Global styles={[globalStyles, typographyStyles, fontStyle]} />
            {props.children}
        </ThemeProvider>
    );
}

export const DEBUG_THEME_KEY = "CandyForms:Debug:Theme";
export const debugThemeStore = {
    // т.к. это debug, то не валидируем получаемое значение
    get: () => localStorage.getItem(DEBUG_THEME_KEY) as ThemeVariant | null,
    set: (nextTheme: ThemeVariant) => localStorage.setItem(DEBUG_THEME_KEY, nextTheme),
    reset: () => localStorage.removeItem(DEBUG_THEME_KEY),
};
